import { Skeleton, Stack, Group, Paper, Box, Table } from '@mantine/core';
import { BrowserView, MobileView } from 'react-device-detect';

export default function ComHubSkeletonLoader() {
  return (
    <>
      <BrowserView>
        <Box data-testid="comhub-loader" w="100%">
          <Table>
            <Table.Tbody>
              {[1, 2, 3, 4, 5].map((item) => (
                <Table.Tr key={item}>
                  {/* Event Name */}
                  <Table.Td w="18%">
                    <Skeleton height={14} width="90%" radius="sm" />
                  </Table.Td>
                  {/* Worker Name */}
                  <Table.Td w="15%">
                    <Skeleton height={14} width="85%" radius="sm" />
                  </Table.Td>
                  {/* Position */}
                  <Table.Td w="20%">
                    <Skeleton height={14} width="80%" radius="sm" />
                  </Table.Td>
                  {/* Location */}
                  <Table.Td w="22%">
                    <Skeleton height={14} width="75%" radius="sm" />
                  </Table.Td>
                  {/* Dates Worked */}
                  <Table.Td w="15%">
                    <Skeleton height={14} width="85%" radius="sm" />
                  </Table.Td>
                  {/* Date/Actions column */}
                  <Table.Td w="10%" style={{ textAlign: 'right' }}>
                    <Skeleton height={14} width="70%" radius="sm" ml="auto" />
                  </Table.Td>
                </Table.Tr>
              ))}
            </Table.Tbody>
          </Table>
        </Box>
      </BrowserView>
      <MobileView>
        <Stack gap="xs" w="100%" p="xs">
          {[1, 2, 3, 4, 5].map((item) => (
            <Paper key={item} shadow="xs" p="md" radius="md" withBorder>
              <Group gap="md" align="flex-start">
                {/* Avatar circle */}
                <Skeleton height={40} width={40} circle />
                {/* Content lines */}
                <Stack gap="xs" style={{ flex: 1 }}>
                  <Skeleton height={14} width="70%" radius="sm" />
                  <Skeleton height={12} width="50%" radius="sm" />
                  <Skeleton height={12} width="60%" radius="sm" />
                </Stack>
              </Group>
            </Paper>
          ))}
        </Stack>
      </MobileView>
    </>
  );
}
